var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { position: "relative" } }, [
    _c("div", { attrs: { id: "middle" } }, [
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isExistence,
            expression: "isExistence",
          },
        ],
        staticClass: "el-icon-arrow-left pointLeft",
        on: { click: _vm.reduce },
      }),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isExistence,
            expression: "isExistence",
          },
        ],
        staticClass: "el-icon-arrow-right pointRight",
        on: { click: _vm.add },
      }),
      _c("img", { attrs: { src: _vm.bigPic } }),
      _vm.isExistence
        ? _c("span", { staticClass: "Page" }, [
            _vm._v(
              _vm._s(_vm.checkedPic + 1) +
                "/" +
                _vm._s(_vm.changePicturesMap.get(_vm.checked).length)
            ),
          ])
        : _vm._e(),
    ]),
    _c("div", { attrs: { id: "bottom" } }, [
      _vm.state === 0
        ? _c("ul", { staticClass: "navAlbum" }, [
            _vm.isExistence && _vm.changePicturesMap.get(0).length > 0
              ? _c(
                  "li",
                  {
                    class: _vm.checked === 0 ? "checked" : "",
                    staticStyle: { width: "120px" },
                    on: {
                      click: function ($event) {
                        return _vm.pointLi(0)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "全部 (" +
                        _vm._s(_vm.changePicturesMap.get(0).length) +
                        ")"
                    ),
                  ]
                )
              : _vm._e(),
            _vm.isExistence && _vm.changePicturesMap.get(1).length > 0
              ? _c(
                  "li",
                  {
                    class: _vm.checked === 1 ? "checked" : "",
                    staticStyle: { width: "120px" },
                    on: {
                      click: function ($event) {
                        return _vm.pointLi(1)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "外观 (" +
                        _vm._s(_vm.changePicturesMap.get(1).length) +
                        ")"
                    ),
                  ]
                )
              : _vm._e(),
            _vm.isExistence && _vm.changePicturesMap.get(2).length > 0
              ? _c(
                  "li",
                  {
                    class: _vm.checked === 2 ? "checked" : "",
                    staticStyle: { width: "120px" },
                    on: {
                      click: function ($event) {
                        return _vm.pointLi(2)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "房间 (" +
                        _vm._s(_vm.changePicturesMap.get(2).length) +
                        ")"
                    ),
                  ]
                )
              : _vm._e(),
            _vm.isExistence && _vm.changePicturesMap.get(3).length > 0
              ? _c(
                  "li",
                  {
                    class: _vm.checked === 3 ? "checked" : "",
                    staticStyle: { width: "120px" },
                    on: {
                      click: function ($event) {
                        return _vm.pointLi(3)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "公共 (" +
                        _vm._s(_vm.changePicturesMap.get(3).length) +
                        ")"
                    ),
                  ]
                )
              : _vm._e(),
            _vm.isExistence && _vm.changePicturesMap.get(4).length > 0
              ? _c(
                  "li",
                  {
                    class: _vm.checked === 4 ? "checked" : "",
                    staticStyle: { width: "120px" },
                    on: {
                      click: function ($event) {
                        return _vm.pointLi(4)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "其他 (" +
                        _vm._s(_vm.changePicturesMap.get(4).length) +
                        ")"
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _vm.isExistence
      ? _c(
          "div",
          { staticClass: "hiddenScrollbar", attrs: { id: "photoWall" } },
          _vm._l(_vm.changePicturesMap.get(_vm.checked), function (pic, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "picKuai",
                class: _vm.checkedPic === index ? "checkedPic" : "",
              },
              [
                _c("img", {
                  attrs: { src: pic },
                  on: {
                    click: function ($event) {
                      return _vm.checkedPicPoint(pic, index)
                    },
                  },
                }),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }